export default {
	name: "מערכת חוגים",
	logo: null,
	rtl: true,
};
